import React, {useState} from 'react'

import FieldProto from "../../../../../proto/field-proto"
import {FieldViewSize} from "../../../../../const";

type Props = {
    className?  : string

    field       : FieldProto

    onClick     : callback      // open dropdown

    children    : any
}

export default function FieldTimeOfDay_ListValueEmpty(props: Props) {
    const size : FieldViewSize = _.get(props, 'size', FieldViewSize.SMALL) as FieldViewSize

    const [isHovered, setIsHovered] = useState(false)

    const onMouseEnter = () => {
        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }

    const classes = Classes("ui5-field-editable ui5-txt-no-accent-small is-empty", "size-"+size, props.className, {
        'is-hovered'        : isHovered || props.children
    })

    return (
        <>
            <div className={classes} onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                {props.field.placeholder}
                {isHovered &&
                    <div className="buttons">
                        <div className="btn-arrow"/>
                    </div>}
            </div>
            {props.children}
        </>
    )
}
